import { NOMEFERMATA_START} from './nomeFermataStartTypes'

const initialState = {
    nomeFermataStart: ""
}

const nomeFermataStartReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case NOMEFERMATA_START:
            
            return {
                nomeFermataStart: action.load
            }
    
        default:
          return state
    }

}


export default nomeFermataStartReducer;